module.exports = __webpack_public_path__ + "static/media/stop-circle.e654ba1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/stop-circle.svg
// module id = 750
// module chunks = 0